import apiClient from "./apiClient"; // Asegúrate de que la ruta es correcta

const consultantsEndpoint = "/consultants";

// Definimos las funciones como constantes, sin el 'export' individual
export const getAllConsultants = async () =>
  apiClient.get(consultantsEndpoint).then((res) => res.data);

export const consultantNamesAndIds = async () =>
  apiClient.get(`${consultantsEndpoint}/names-and-ids`).then((res) => res.data);

export const getConsultantById = async (id) =>
  apiClient.get(`${consultantsEndpoint}/${id}`).then((res) => res.data);

export const deleteConsultantImage = async (id, form, from) => {
  // En tu código original, 'form' se convierte a JSON, así que lo pasamos como un objeto.
  return apiClient
    .put(`${consultantsEndpoint}/delete-image/${from}/${id}`, form)
    .then((res) => res.data);
};

export const createConsultant = async (form) => {
  // Asumimos que 'form' es FormData, ya que permite subir imágenes.
  // Axios lo manejará correctamente.
  return apiClient
    .post(`${consultantsEndpoint}/create`, form)
    .then((res) => res.data);
};

export const updateConsultant = async (form) => {
  // Asumimos que 'form' es FormData para poder actualizar imágenes.
  return apiClient
    .put(`${consultantsEndpoint}/edit`, form)
    .then((res) => res.data);
};

export const deleteConsultant = async (id) =>
  apiClient
    .delete(`${consultantsEndpoint}/delete/${id}`)
    .then((res) => res.data);
